/**
 * Mirrors the backend enum `AIVectorFileSyncStatus`.
 *
 * The C# definition uses `[EnumMember(Value = "...")]` so some surfaces may
 * serialize kebab-case strings, but the API returns the NUMERIC value
 * (e.g. `syncStatus: 2`). Numeric values are the source of truth here.
 *
 *   NotSynced = 1  ("not-synced")
 *   Synced    = 2  ("synced")
 *   Failed    = 3  ("failed")
 */
export default Object.freeze({
  NotSynced: 1, // "not-synced"
  Synced: 2, // "synced"
  Failed: 3, // "failed"
});
